import React, { useMemo, useRef } from 'react';

import { ConfirmDialog } from '../_core/_ui/confirm-dialog.component';
import { IntlMsg } from '../_core/IntlMsg/intl-msg.component';
import { reportCardConfirmCopy } from './report-card-access.helpers';
import { ConfirmedReportCardWrite, ReportCardAccessMessages } from './report-card-access.types';

interface IReportCardWriteConfirmDialogProps {
  action: ConfirmedReportCardWrite | null;
  name: string;
  messages: ReportCardAccessMessages;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ReportCardWriteConfirmDialog: React.FC<IReportCardWriteConfirmDialogProps> = ({
  action,
  name,
  messages,
  onConfirm,
  onCancel,
}) => {
  const copyByAction = useMemo(() => reportCardConfirmCopy(messages), [messages]);
  // Keeps the last action's copy on screen while the dialog fades out after a choice.
  const shown = useRef<ConfirmedReportCardWrite>('RESEND');
  if (action) shown.current = action;
  const copy = copyByAction[shown.current];
  const values = { name };

  return (
    <ConfirmDialog
      open={!!action}
      title={<IntlMsg {...copy.title} values={values} />}
      message={<IntlMsg {...copy.body} values={values} />}
      confirmLabel={<IntlMsg {...copy.button} />}
      cancelLabel={<IntlMsg {...messages.btnCancel} />}
      onConfirm={onConfirm}
      onCancel={onCancel}
      destructive={copy.destructive}
    />
  );
};
